import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { GalleryDto, GalleryPublicAccessLevel } from '@nusign/picflow-backend-types';
import { switchMap } from 'rxjs';
import { GalleryService } from '../../../services/gallery.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { AccessItemBodyComponent } from '../access-item-body/access-item-body.component';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemComponent } from '../access-item/access-item.component';

@Component({
  selector: 'app-gallery-public-access-item',
  imports: [
    ButtonDirective,
    SvgComponent,
    AccessItemComponent,
    AccessItemHeaderComponent,
    AccessItemBodyComponent,
    AccessItemCtaComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './gallery-public-access-item.component.html',
  styleUrl: './gallery-public-access-item.component.scss',
})
export class GalleryPublicAccessItemComponent {
  private galleryService = inject(GalleryService);
  gallery = input.required<GalleryDto>();
  editLink = output<void>();
  publicAccessLevels: GalleryPublicAccessLevel[] = ['review', 'view_only', 'no_access'];
  publicAccessLevel = toSignal(
    toObservable(this.gallery).pipe(switchMap(gallery => this.galleryService.getEffectivePublicAccessLevel(gallery)))
  );

  icon = computed(() => {
    const gallery = this.gallery();
    const publicAccessLevel = this.publicAccessLevel();
    if (!gallery || !publicAccessLevel) return;
    if (publicAccessLevel === 'no_access') return '/assets/icons/globe-disabled.svg';
    if (gallery.password_enabled) return '/assets/icons/globe-lock.svg';
    return '/assets/icons/globe-outline.svg';
  });

  iconColor = computed(() => {
    const gallery = this.gallery();
    const publicAccessLevel = this.publicAccessLevel();
    if (!gallery || !publicAccessLevel) return;
    if (publicAccessLevel === 'no_access') return 'red';
    if (gallery.password_enabled) return 'orange';
    return 'green';
  });
}
